import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _LinkIcon, _FacebookIcon, _LinkedIn;
import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import LinkedIn from '@mui/icons-material/LinkedIn';
import CloseIcon from '@mui/icons-material/Close';
import LinkIcon from '@mui/icons-material/Link';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import FacebookIcon from '../statelessComponents/Icons/FacebookIcon';
import s from './ShareCertificateModal.scss';
import intlPropTypes from '../../constants/intlPropTypes';
var messages = defineMessages({
  title: {
    id: "Cert.ShareCertificateModal.title",
    defaultMessage: [{
      "type": 0,
      "value": "Share this certificate"
    }]
  },
  copyLinkBtnTooltip: {
    id: "Cert.ShareCertificateModal.copyLinkBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Copy the certificate link"
    }]
  },
  shareCertToFBBtnTooltip: {
    id: "Cert.ShareCertificateModal.shareCertToFBBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Share on Facebook"
    }]
  },
  shareCertToLinkedInBtnTooltip: {
    id: "Cert.ShareCertificateModal.shareCertToLinkedInBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Share on LinkedIn"
    }]
  },
  copyBtnMessage: {
    id: "Cert.ShareCertificateModal.copyBtnMessage",
    defaultMessage: [{
      "type": 0,
      "value": "Link copied to clipboard"
    }]
  }
});
var ShareCertificateModal = function ShareCertificateModal(_ref) {
  var onClose = _ref.onClose,
    certPage = _ref.certPage,
    certId = _ref.certId,
    formatMessage = _ref.intl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openSnackbar = _useState4[0],
    setOpenSnackbar = _useState4[1];
  var shareUrl = "".concat(window.location.origin, "/").concat(certPage);
  var handleCopy = function handleCopy() {
    navigator.clipboard.writeText(shareUrl).then(function () {
      setCopied(true);
      setOpenSnackbar(true);
    });
  };
  var shareToLinkedInHandler = function shareToLinkedInHandler() {
    window.open("https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(shareUrl)), '_blank');
  };
  var shareToFacebookHandler = function shareToFacebookHandler() {
    window.open("https://www.facebook.com/sharer/sharer.php?&u=".concat(encodeURIComponent(shareUrl)), '_blank');
  };
  var handleCloseSnackbar = function handleCloseSnackbar() {
    setOpenSnackbar(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("div", {
    className: s.paper,
    tabIndex: "-1"
  }, void 0, /*#__PURE__*/_jsx(Typography, {
    className: s.text,
    variant: "subtitle1"
  }, void 0, formatMessage(messages.title)), /*#__PURE__*/_jsx("div", {
    className: s.btnsContainer
  }, void 0, /*#__PURE__*/_jsx(Tooltip, {
    title: formatMessage(messages.copyLinkBtnTooltip)
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "lKhPYTukl8Sj0-OtpBZDz",
    variant: "contained",
    color: "primary",
    className: s.button,
    onClick: handleCopy
  }, void 0, _LinkIcon || (_LinkIcon = /*#__PURE__*/_jsx(LinkIcon, {})))), /*#__PURE__*/_jsx(Tooltip, {
    title: formatMessage(messages.shareCertToFBBtnTooltip)
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "Vc1iH-QYaUrnvMjcn04on",
    variant: "contained",
    color: "primary",
    className: s.button,
    onClick: shareToFacebookHandler
  }, void 0, _FacebookIcon || (_FacebookIcon = /*#__PURE__*/_jsx(FacebookIcon, {
    color: "white"
  })))), /*#__PURE__*/_jsx(Tooltip, {
    title: formatMessage(messages.shareCertToLinkedInBtnTooltip)
  }, void 0, /*#__PURE__*/_jsx(Button, {
    "data-test-id": "hwJ-jvsWkMwMc-9OhhGCl",
    variant: "contained",
    color: "primary",
    className: s.button,
    onClick: shareToLinkedInHandler
  }, void 0, _LinkedIn || (_LinkedIn = /*#__PURE__*/_jsx(LinkedIn, {}))))), /*#__PURE__*/_jsx("div", {
    className: s.closeModalBtn
  }, void 0, /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": "bnF3jer_CBxDET_jkcksC",
    onClick: onClose
  }, void 0, /*#__PURE__*/_jsx(CloseIcon, {
    className: s.closeIcon
  })))), /*#__PURE__*/_jsx(Snackbar, {
    open: copied && openSnackbar,
    onClose: handleCloseSnackbar,
    autoHideDuration: 8000,
    message: formatMessage(messages.copyBtnMessage)
  }, "successfullyCopiedLink-".concat(certId)));
};
export default injectIntl(withStyles(s)(connect(function (state) {
  return {
    lang: state.intl.locale
  };
})(ShareCertificateModal)));